
window.HH = window.HH || {};

(function (HH) {
    'use strict';

    if (typeof gsap === 'undefined') {
        return;
    }

    /* On n'enregistre que ce que le bundle contient vraiment : la liste
       des plugins concatenes vit dans gulpfile.js et peut bouger. */
    ['SplitText', 'ScrollTrigger'].forEach(function (nom) {
        if (typeof window[nom] !== 'undefined') {
            gsap.registerPlugin(window[nom]);
        }
    });

    gsap.defaults({
        ease: 'power3.out',
        duration: 0.6
    });

    /**
     * Reglages par defaut de la revelation en lignes. Chaque bloc peut
     * les surcharger au cas par cas via le 4e argument.
     */
    var LIGNES = {
        duree: 0.7,
        decalage: 0.09,
        ease: 'power4.out'
    };

    /**
     * SplitText mesure les lignes telles qu'elles sont au moment ou il
     * passe. Sur une police custom encore en cours de chargement, il les
     * coupe sur la police de substitution et le texte reste casse. On
     * l'attend, sans se laisser retenir : au-dela de 300 ms, la police
     * n'est plus notre probleme.
     */
    HH.policesPretes = function () {
        var attente = document.fonts && document.fonts.ready
            ? document.fonts.ready
            : Promise.resolve();

        var borne = new Promise(function (resolve) {
            setTimeout(resolve, 300);
        });

        return Promise.race([attente, borne]);
    };

    /**
     * Element decoupe en lignes, chacune revelee derriere son masque.
     * L'element redevient visible une fois ses lignes deja sorties du
     * cadre du masque, sinon il apparaitrait en entier d'un coup.
     *
     * A appeler apres HH.policesPretes(), et sur un element deja pose a
     * opacity 0 par le bloc appelant.
     */
    HH.revelerEnLignes = function (tl, element, position, reglages) {
        if (!element) {
            return;
        }

        var r = Object.assign({}, LIGNES, reglages || {});

        /* Plugin absent du bundle : on retombe sur un fondu plutot que de
           laisser l'element a opacity 0. */
        if (typeof SplitText === 'undefined') {
            tl.to(element, {opacity: 1, duration: r.duree}, position);
            return;
        }

        var decoupe = SplitText.create(element, {
            type: 'lines',
            mask: 'lines'
        });

        gsap.set(decoupe.lines, {yPercent: 100});
        gsap.set(element, {opacity: 1});

        tl.to(decoupe.lines, {
            yPercent: 0,
            duration: r.duree,
            stagger: r.decalage,
            ease: r.ease,
            /* le balisage d'origine est restitue une fois l'animation
               terminee : les lignes decoupees ne lui survivent pas */
            onComplete: function () {
                decoupe.revert();
            }
        }, position);
    };
})(window.HH);
